module.exports = __webpack_public_path__ + "static/media/crdscib.624e9569.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdscib.png
// module id = 175
// module chunks = 0